import FJImage from '../../../common/components/FJImage/FJImage';
import styles from './FJMobileStyleList.module.less';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../store/FJLocalStore';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import NewIcon from '../../../assets/svg/new.svg?react';
import classNames from 'classnames';
import { useMemo, useRef } from 'react';
import FJConfig from '../../../config/FJConfig';
let scrollTimer = null;
const FJMobileStyleList = props => {
    const { list = [], onChange, value, selectStyleCategory, setSelectStyleCategory } = props;
    const scrollRef = useRef(null);
    const isScrollingRef = useRef(false);
    const categoryList = useMemo(() => {
        return list.map(item => item.categoryName);
    }, [list]);
    const styleList = useMemo(() => {
        return list.reduce((calc, cur) => [...calc, ...cur.list], []);
    }, [list]);
    const uniqueKeyValue = useMemo(() => {
        return styleList.find(i => i.value === value).uniqueKey;
    }, [styleList, value]);
    const _scroll = left => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({
                left,
                behavior: 'smooth',
            });
        }
    };
    const _onChangeCategory = index => {
        if (index === selectStyleCategory) {
            return;
        }
        if (scrollRef.current) {
            // 当前分类前面的元素个数
            const itemIdx = list.reduce((calc, cur, idx) => calc + (index > idx ? cur.list.length : 0), 0);
            const children = Array.from(scrollRef.current.children);
            // 判断是选中分类是否有选中元素
            const selectStyleIdx = list[index].list.findIndex(i => i.uniqueKey === uniqueKeyValue);
            if (selectStyleIdx !== -1) {
                _scrollToSelectMiddle();
            } else {
                isScrollingRef.current = true;
                let scrollLeft = children[itemIdx].offsetLeft - 16;
                _scroll(scrollLeft);
            }
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => {
                isScrollingRef.current = false;
            }, 1000);
        }

        setSelectStyleCategory && setSelectStyleCategory(index);
    };
    // 滚动到选中元素且居中
    const _scrollToSelectMiddle = uniqueKey => {
        if (scrollRef.current) {
            const item = uniqueKey || uniqueKeyValue;
            const count = _getStyleIndex(item);
            const children = Array.from(scrollRef.current.children);
            const containerWidth = scrollRef.current.offsetWidth;
            const childrenWidth = children[count].offsetWidth;
            const scrollLeft = children[count].offsetLeft - 16 - containerWidth / 2 + childrenWidth / 2;
            _scroll(scrollLeft);
        }
    };
    const _getStyleIndex = uniqueKey => {
        let isFind = false;
        // 当前分类前面的元素个数
        return list.reduce((calc, cur) => {
            const index = cur.list.findIndex(i => i.uniqueKey === uniqueKey);
            if (index !== -1) {
                isFind = true;
                return index + calc;
            } else if (!isFind) {
                return calc + cur.list.length;
            } else {
                return calc;
            }
        }, 0);
    };
    const _onScroll = e => {
        if (scrollRef.current && !isScrollingRef.current) {
            const scrollLeft = e.target.scrollLeft;
            const offsetWidth = e.target.offsetWidth;
            const children = Array.from(scrollRef.current.children);
            let categoryIdx = 0;
            // 判断当前选中是否再可可视界面
            const selectStyleIdx = _getStyleIndex(uniqueKeyValue);
            if (
                children[selectStyleIdx] &&
                scrollLeft < children[selectStyleIdx].offsetLeft &&
                scrollLeft + offsetWidth > children[selectStyleIdx].offsetLeft
            ) {
                categoryIdx = list.findIndex(item => item.list.findIndex(i => i.uniqueKey === uniqueKeyValue) !== -1);
            } else {
                for (let i = 0; i < list.length; i++) {
                    const num = list.reduce((calc, cur, idx) => calc + (i >= idx ? cur.list.length : 0), 0);
                    const nextChildDom = children[num];
                    //判断前分类最后一个元素的位置
                    if (nextChildDom && scrollLeft > nextChildDom.offsetLeft - 20) {
                        categoryIdx = i + 1;
                    } else {
                        break;
                    }
                }
            }
            setSelectStyleCategory(categoryIdx);
        }
    };
    const _onSelectStyle = item => {
        onChange(item.value);
        _scrollToSelectMiddle(item.uniqueKey);
    };
    return (
        <div className={styles.style_list_box}>
            <div className={styles.header}>
                <div className={styles.title}>{FJLocalStore._('style')}</div>
                <div className={styles.category_list}>
                    {categoryList.map((item, index) => (
                        <FJHoverBoardGradation
                            key={index}
                            active={index === selectStyleCategory}
                            contentClassName={styles.category_item_text}
                            selectBgColor={'#fff'}
                            onClick={() => _onChangeCategory(index)}
                            className={styles.category_item}
                        >
                            {FJLocalStore._(item)}
                        </FJHoverBoardGradation>
                    ))}
                </div>
            </div>
            <div className={styles.style_list} ref={scrollRef} onScroll={_onScroll}>
                {styleList.map(item => (
                    <FJHoverBoardGradation
                        key={item.uniqueKey}
                        active={item.value === value}
                        className={classNames(styles.style_item_box)}
                        contentClassName={styles.style_item}
                        onClick={() => {
                            _onSelectStyle(item);
                        }}
                    >
                        {item.isNew && <NewIcon className={styles.new} />}

                        <FJImage imgSrc={FJConfig.stylePath + item.img + `?v=${FJConfig.version}`} />
                        <div className={styles.style_item_name}>{FJLocalStore._(item.name)}</div>
                    </FJHoverBoardGradation>
                ))}
            </div>
        </div>
    );
};
FJMobileStyleList.propTypes = {
    selectStyleCategory: PropTypes.number,
    list: PropTypes.array,
    onChange: PropTypes.func,
    value: PropTypes.string,
    setSelectStyleCategory: PropTypes.func,
};
export default FJMobileStyleList;
